import { Navigate, Route, Routes } from "react-router-dom";

import { AppIdentityRoutingModule } from "./modules/App.Identity.RoutingModule";
import { AppPortal } from "./lib/layouts/portal/AppPortal";
import { AppRoutingModule } from "./modules/App.RoutingModule";
import { ArkShell } from "./modules/shell/ArkShell";
import { EmbededDocumentationPage } from "./features/documentation/pages/documentation-home-page/EmbededDocumentationPage";
import { RequireAuth } from "./lib/infrastructure/identity/components/RequireAuth";
import { SplashScreen } from './common/components/splash-screen/SplashScreen';
import { ToastProvider } from "./ds";
import { useIdentityIsProcessing } from './lib/infrastructure/identity/hooks/useIdentityIsProcessing';

function App() {
  const isProcessing = useIdentityIsProcessing();

  if (isProcessing) return <SplashScreen />;

  // MSAL's silent / popup flows land in a hidden iframe with the response in the hash.
  if (window.location.hash !== '' && window.parent !== window) {
    return <>login success</>;
  }

  return (
    // The library toasts (useFeedback and the popup / notification bridges raise them).
    <ToastProvider>
      <AppPortal>
        <Routes>
          <Route path="/" element={<Navigate to="/spaces" />} />
          <Route path="/splashshet" element={<SplashScreen />} />
          <Route path="/identity/*" element={<AppIdentityRoutingModule />} />
          {/* Embedded pages (Atlas, Vision) have no shell. */}
          <Route path="/embeded/spaces/:spaceId/pages/:pageId" element={<RequireAuth><EmbededDocumentationPage /></RequireAuth>} />
          <Route path="*" element={<RequireAuth><ArkShell><AppRoutingModule /></ArkShell></RequireAuth>} />
        </Routes>
      </AppPortal>
    </ToastProvider>
  );
}

export default App;
